/** @file Checks that a list is a permutation of 0..count-1 and returns its inverse (vertex maps, W2-29). */
import { throwError } from '@pose2d/format/throwError';

/** inverse[map[i]] = i; VALIDATION at `path` for a wrong length, at `<path>.<i>` for an entry out of range or repeated. */
export function invertPermutation(map: readonly number[], count: number, path: string): number[] {
  if (map.length !== count) throwError('VALIDATION', undefined, { path, hint: `expected ${count} entries, one per vertex` });
  const inverse = new Array<number>(count).fill(-1);
  map.forEach((j, i) => {
    if (!Number.isInteger(j) || j < 0 || j >= count || inverse[j] !== -1) throwError('VALIDATION', undefined, { path: `${path}.${i}`, hint: `entries must be distinct integers in 0..${count - 1}` });
    inverse[j] = i;
  });
  return inverse;
}
